module.exports = __webpack_public_path__ + "static/media/skdzzBackground.a8dfa97f.jpg";